<template>
    <div style="width:1024px;" v-if="quoteData.id" color="white" class="mr-1">
        <v-layout bg-color="blue">
            <v-flex xs4>
                <!-- <v-img
                :src="require('../assets/hm_logo_blue.png')"
                contain
                width="250" height="80" 
                ></v-img> -->
                <!-- <v-img
                :src="require(quotedByCompanyData.logoPath)"
                contain
                width="250" height="80" 
                ></v-img> -->
                <v-img
                :src="quotedByCompanyData.logoPath"
                contain
                width="250" height="80" 
                ></v-img>
            </v-flex>
            <v-flex xs4 pt-5 class="display-2 font-weight-bold text-xs-center " grey--text text--darken-2>
                <div color="">Quotation</div>
            </v-flex>
            <v-flex xs4 body-2 grey--text bold class="">
                <v-spacer></v-spacer>
                <div class="text-xs-right">18600 Malyn Blvd.</div>
                <div class="text-xs-right">Fraser, MI 48026 USA</div>
                <div class="text-xs-right">Telephone: (800) 521-6224</div>
                <div class="text-xs-right">Fax: (586) 491-2113</div>
                <div class="text-xs-right">Email: HMorders@hmark.com</div>
                <div class="text-xs-right">www.hmark.com</div>
            </v-flex>
        </v-layout>
        <!-- <div class="display-1 font-weight-bold text-xs-center">Quotation</div> -->
        <v-layout pt-3 wrap>
            <v-flex xs6>
                <v-layout row wrap><v-flex xs4 subheading>FACILITY:	</v-flex><v-flex xs7 class="subheading font-weight-bold text-xs-left">{{quoteData.basicInfo.facilityName | morph-uppercase }}</v-flex></v-layout>
                <v-layout row wrap>
                  <v-flex xs4 subheading>ADDRESS:	</v-flex>
                  <v-flex xs7 class="subheading font-weight-bold text-xs-left">{{ quoteData.basicInfo.facilityAddress2 | morph-uppercase }} 
                    <br>{{ quoteData.basicInfo.facilityCity }}, 
                    {{ quoteData.basicInfo.facilityState }} 
                    {{ quoteData.basicInfo.facilityZip }} 
                    {{ quoteData.basicInfo.facilityCountry == 'USA'? '' : quoteData.basicInfo.facilityCountry}}</v-flex>
                </v-layout>
                <v-layout row wrap><v-flex xs4 subheading>CONTACT NAME:	</v-flex><v-flex xs7 class="subheading font-weight-bold text-xs-left">{{ quoteData.basicInfo.contactName | morph-uppercase }}</v-flex></v-layout>
                <v-layout row wrap>
                  <v-flex xs4 subheading>DEPT. / TITLE:	</v-flex>
                  <v-flex xs8 class="subheading font-weight-bold text-xs-left">
                    {{ quoteData.basicInfo.department | morph-uppercase }}
                    /
                    {{ quoteData.basicInfo.title | morph-uppercase }}
                  </v-flex>
                </v-layout>
                <v-layout row wrap>
                  <v-flex xs1 subheading><v-icon>phone</v-icon>	</v-flex><v-flex xs4 class="subheading font-weight-bold text-xs-left">{{ quoteData.basicInfo.phone }}</v-flex>
                <!-- </v-layout>
                <v-layout row wrap> -->
                  <v-flex xs1 subheading><v-icon>mail</v-icon></v-flex><v-flex xs6 class="subheading font-weight-bold text-xs-left">{{ quoteData.basicInfo.email | morph-uppercase }}</v-flex>
                </v-layout>
                <!-- <v-layout row wrap>
                </v-layout>
                <v-layout row wrap>
                </v-layout> -->
                <!-- <v-layout row wrap><v-flex xs4 subheading>PRICE LEVEL:	</v-flex><v-flex xs7 class="subheading font-weight-bold text-xs-left">{{ quoteData.basicInfo.facilityPriceLevel | morph-uppercase }}</v-flex></v-layout>
                <v-layout row wrap><v-flex xs4 subheading>TERRITORY: 	</v-flex><v-flex xs7 class="subheading font-weight-bold text-xs-left">{{ quoteData.basicInfo.facilityTerritory | morph-uppercase }}</v-flex></v-layout>
                <v-layout row wrap><v-flex xs4 subheading>REGION:	</v-flex><v-flex xs7 class="subheading font-weight-bold text-xs-left">{{ quoteData.basicInfo.facilityRegion | morph-uppercase }}</v-flex></v-layout> -->

            </v-flex>
            <v-flex xs1></v-flex>
            <v-flex xs5 subheading>
                <v-layout row >
                    <v-flex xs6 pa-1 subheading class="font-weight-bold text-xs-center" grey lighten-1>ACCT #	</v-flex>
                    <v-flex xs6 pa-1 subheading class="font-weight-bold text-xs-center" grey lighten-1 ml-1>QUOTE #</v-flex>
                </v-layout>
                <v-layout row >
                    <v-flex xs6 pa-1 subheading class="font-weight-bold text-xs-center" grey lighten-2 >{{quoteData.basicInfo.facilityAcctNo}}</v-flex>
                    <v-flex xs6 pa-1 subheading class="font-weight-bold text-xs-center" grey lighten-2 ml-1>{{ quoteData.basicInfo.num }} - {{ quoteData.basicInfo.ver }}</v-flex>
                </v-layout>
                <v-layout row mt-1>
                    <v-flex xs6 pa-1 subheading class="font-weight-bold text-xs-center" grey lighten-1>QUOTE DATE</v-flex>
                    <v-flex xs6 pa-1 subheading class="font-weight-bold text-xs-center" grey lighten-1 ml-1>EXPIRATION DATE</v-flex>
                </v-layout>
                <v-layout row >
                    <v-flex xs6 pa-1 subheading class="font-weight-bold text-xs-center" grey lighten-2>{{ quoteData.basicInfo.quoteDate | morph-date('MM/DD/YYYY') }}</v-flex>
                    <v-flex xs6 pa-1 subheading class="font-weight-bold text-xs-center" grey lighten-2 ml-1>{{ quoteData.basicInfo.expirationDate | morph-date('MM/DD/YYYY') }}</v-flex>
                </v-layout>

            </v-flex>
        </v-layout>
        <v-layout row>
            <!-- <v-flex xs4>
              <v-layout row wrap><v-flex xs4 subheading>PRICE LEVEL:	</v-flex><v-flex xs7 class="subheading font-weight-bold text-xs-left">{{ quoteData.basicInfo.facilityPriceLevel | morph-uppercase }}</v-flex></v-layout>
            </v-flex> -->
            <v-flex xs8 v-if="quoteData.basicInfo.soldToCode">
              <v-layout row wrap><v-flex xs3 subheading>Customer:	</v-flex><v-flex xs9 class="subheading font-weight-bold text-xs-left">{{ quoteData.basicInfo.soldToCode }} / {{ quoteData.basicInfo.soldToName | morph-uppercase }}</v-flex></v-layout>
            </v-flex>
            <v-flex xs4>
              <v-layout row wrap><v-flex xs4 subheading>GPO Affiliated:	</v-flex><v-flex xs7 class="subheading font-weight-bold text-xs-left">{{ quoteData.basicInfo.gpoAffiliated }}</v-flex></v-layout>
            </v-flex>
            <!-- <v-flex xs4>
              <v-layout row wrap><v-flex xs4 subheading>TERRITORY: 	</v-flex><v-flex xs7 class="subheading font-weight-bold text-xs-left">{{ quoteData.basicInfo.facilityTerritory | morph-uppercase }}</v-flex></v-layout>
            </v-flex>
            <v-flex xs4>
              <v-layout row wrap><v-flex xs4 subheading>REGION:	</v-flex><v-flex xs7 class="subheading font-weight-bold text-xs-left">{{ quoteData.basicInfo.facilityRegion | morph-uppercase }}</v-flex></v-layout>
            </v-flex> -->

        </v-layout>
        <v-layout pt-3>
            <v-flex xs12>
                <v-data-table
                    :headers="headers"
                    :items="quoteData.items"
                    class="elevation-1"
                    hide-actions
                >
                    <template slot="items" slot-scope="props">
                      <td class="py-1">
                          <v-img
                              :src="props.item.imgThumbnailUrl"
                              width="150"
                              aspect-ratio="1.5"
                              contain
                          ></v-img>
<!-- <v-img src="https://healthmark.canto.com/preview/image/ncaoljr3455v36q3ibqiir1c1h/300"
    height="80"
    width="120"
>
</v-img> -->

                      </td>

                      <td class="subheading text-no-wrap">{{ props.item.catalogNum }}</td>
                      <td class="subheading">{{ props.item.description }}</td>
                      <td class="subheading text-no-wrap">{{ props.item.unit }}</td>
                      <td class="subheading text-xs-right">{{ props.item.qty }}</td>
                          <!-- {{ !props.item.unitPrice? "0.00" : props.item.unitPrice | toCurrency }} -->
                      <td class="subheading text-xs-right">{{ formatCurrency((!props.item.unitPrice? 0 : props.item.unitPrice), props.item.currnIdx) }}</td>
                      <!-- <td class="subheading text-xs-right">{{ props.item.discountPct? (props.item.discountPct + '%') :'n/a' }}</td> -->
                      <td class="subheading text-xs-right">{{ formatCurrency((!props.item.totalPrice? 0 : props.item.totalPrice), props.item.currnIdx) }}
                        <!-- <div class="body-1" v-if="props.item.discountPct">
                          {{ props.item.discountPct? ('(Discount: ' + props.item.discountPct + '%)') :'' }}
                        </div> -->
                        <div class="body-1" >{{getItemPromotionOrDiscountSummary(props.item)}}</div>

                      </td>
                    </template>
                    <template slot="footer">
                    <td :colspan="headers.length-2" class="py-3">
                        <v-layout row ><v-flex xs2 class="subheading font-weight-bold text-xs-left">TERMS:	</v-flex><v-flex xs6 pl-3 body-2 class="">{{ quoteData.basicInfo.paymentType }}</v-flex></v-layout>
                        <v-layout row ><v-flex xs2 class="subheading font-weight-bold text-xs-left">FREIGHT:	</v-flex><v-flex xs6 pl-3 body-2 class="">{{ quoteData.basicInfo.facilityShipMethod.value }}</v-flex></v-layout>

                    </td>
                    <td colspan="2" >
                        <v-layout row v-show="showQuoteTotal">
                            <v-flex xs6 class="subheading font-weight-bold">Total</v-flex>
                            <v-flex xs6 class="subheading font-weight-bold text-xs-right">
                              <!-- {{ !quoteData.basicInfo.totalAmount? "0.00" : quoteData.basicInfo.totalAmount | toCurrency }} -->
                              {{ formatCurrency((!quoteData.basicInfo.totalAmount? 0 : quoteData.basicInfo.totalAmount), quoteData.basicInfo.totalAmountCurrnIdx) }}
                            </v-flex>
                        </v-layout>
                      </td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
        <v-layout row v-show="quoteData.basicInfo.freightInfo">
          <v-flex xs2 subheading pt-1>Freight Information:</v-flex>
          <v-flex xs10 text-xs-left pt-1 style="white-space:pre;">{{ quoteData.basicInfo.freightInfo }}</v-flex>
        </v-layout>
        <v-layout row v-show="quoteData.basicInfo.notes">
          <v-flex xs2 subheading pt-1>Special Instruction:</v-flex>
          <v-flex xs10 text-xs-left pt-1 style="white-space:pre;">{{ quoteData.basicInfo.notes }}</v-flex>
        </v-layout>
        <v-layout pt-3>
          <v-flex xs4 v-show="quoteData.basicInfo.salesRep.name">
            <v-card>
              <v-card-text>
                  <div class="body-2">Field Representative</div>
                  <v-divider></v-divider>
                  <div class="subheading text-xs-center">{{quoteData.basicInfo.salesRep.name}}</div>
                  <div class=" text-xs-center">
                      <v-icon>phone</v-icon>
                      {{quoteData.basicInfo.salesRep.phone}}
                  </div>
                  <div class="text-xs-center">
                    <v-icon>mail</v-icon>
                    <a :href="'mailto:' + quoteData.basicInfo.salesRep.email"
                    class="black--text"
                    style="text-decoration: none !important;">
                      {{ quoteData.basicInfo.salesRep.email }}
                    </a>
                  </div>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs4 mx-2>
            <v-card>
                <v-card-text>
                    <div class="body-2">Customer Service Representative</div>
                    <v-divider></v-divider>
                    <div class="subheading text-xs-center">{{quoteData.basicInfo.csRep.name}}</div>
                    <div class=" text-xs-center">
                      <v-icon>phone</v-icon>
                      {{quoteData.basicInfo.csRep.phone}}
                    </div>
                    <div class="text-xs-center">
                      <v-icon>mail</v-icon>
                      <a :href="'mailto:' + quoteData.basicInfo.csRep.email"
                      class="black--text"
                      style="text-decoration: none !important;">
                        {{ quoteData.basicInfo.csRep.email }}
                      </a>
                    </div>
                </v-card-text>
              </v-card>
          </v-flex>
          <v-flex xs4>
            <v-card>
                <v-card-text>
                    <div class="body-2">Inside Representative</div>
                    <v-divider></v-divider>
                    <div class="subheading text-xs-center">{{quoteData.basicInfo.isRep.name}}</div>
                    <div class=" text-xs-center">
                      <v-icon>phone</v-icon>
                      {{quoteData.basicInfo.isRep.phone}}
                    </div>
                    <div class="text-xs-center">
                      <v-icon>mail</v-icon>
                      <a :href="'mailto:' + quoteData.basicInfo.isRep.email"
                        class="black--text"
                        style="text-decoration: none !important;">
                        {{ quoteData.basicInfo.isRep.email }}
                      </a>
                    </div>
                    
                  <!-- <v-layout>
                    <v-list-tile-action>
                      
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>{{quoteData.basicInfo.isRep.phone}}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-layout>
                  <v-layout>
                    <v-list-tile-action>
                      <v-icon>mail</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                      <v-list-tile-title>{{quoteData.basicInfo.isRep.email}}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-layout> -->
                </v-card-text>
              </v-card>
          </v-flex>
        </v-layout>
        <v-layout row>
            <v-flex xs4>
              <v-layout row wrap><v-flex xs4 subheading>TERRITORY: 	</v-flex><v-flex xs7 class="subheading font-weight-bold text-xs-left">{{ quoteData.basicInfo.facilityTerritory | morph-uppercase }}</v-flex></v-layout>
            </v-flex>
            <v-flex xs4>
              <v-layout row wrap><v-flex xs4 subheading>REGION:	</v-flex><v-flex xs7 class="subheading font-weight-bold text-xs-left">{{ quoteData.basicInfo.facilityRegion | morph-uppercase }}</v-flex></v-layout>
            </v-flex>

        </v-layout>
<!-- {{quoteData}} -->
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: ['quoteData'],
  components: {
  },
  data: () => ({
    // quoteData: null,
    headers: [
        { text: '', sortable: false},
        { text: 'Catalog #', sortable: false},
        { text: 'DESCRIPTION' , sortable: false},
        { text: 'UNIT' , sortable: false},
        { text: 'QTY', sortable: false},
        { text: 'UNIT PRICE' , sortable: false},
        // { text: 'DISCOUNT' , sortable: false},
        { text: 'TOTAL' , sortable: false, align: 'right'},
    ],
  }),
  computed: {
    ...mapGetters("auth", ["loggedIn"]),
    id() {
      return this.$route.params.id;
    },
    quotedByCompanyData() {
      return this.quoteData && this.quoteData.basicInfo.quotedByCompany === 'LTA'?
        {
          logoPath: require('@/assets/lta_Logo.png')
        }
        :
        {
          logoPath: require('@/assets/hm_logo_blue.png')
        }

    },
    showQuoteTotal() {
      return !this.quoteData.basicInfo.isCustomQuote && !this.quoteData.basicInfo.hideTotalAmtInPdf
    },
    error() {
      return this.$store.getters.error;
    }
  },
  watch: {},
  methods: {
      // ...mapActions('pubQuoteEdit', [
      //     'populateQuoteEditDataForInternalRep',
      // ]),
      // async loadQuoteData() {
      //   this.quoteData = await this.populateQuoteEditDataForInternalRep(this.id)

      // },
      getItemPromotionOrDiscountSummary(itemData) {
            const promotion = itemData.promotionApplied
            
            if(!promotion) {
                return itemData.discountPct? `(Discount: ${itemData.discountPct}%)` :''
            }
            
            //has promotion
            if (promotion.promotionType === "DiscountPct") {
                return `(Promotion Discount: ${promotion.promotionAmt}%)`;
            } else if (promotion.promotionType === "PromotionPrice"){
                return `(Promotion Unit Price: $${promotion.promotionAmt})`;
            } else if (promotion.promotionType === "BuyXGetYFree"){
                return `(Promotion: Buy ${promotion.buyXGetYFreeBuyQty} Get ${promotion.buyXGetYFreeGetQty} Free)`;
            }
            // else {
            //     return `(Promotion Unit Price: $${promotion.promotionAmt} ${discountApprovalMsg})`;
            // }

        },
      onDismissed() {
    }
  },
  created: async function() {
    // if (this.initQuoteData) {
    //   this.quoteData = Object.assign({}, this.initQuoteData)
    // } else {
    //   await this.loadQuoteData()

    // }
  },
  mounted: function() {},
  destroyed: function() {
    // this.onDismissed();
  }
};
</script>